import { render, staticRenderFns } from "./TicketsList.vue?vue&type=template&id=7124e3de"
import script from "./TicketsList.vue?vue&type=script&lang=js"
export * from "./TicketsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports